<template lang="pug">
  div.map-container.geo.map-objects
    div.toolbar
      div.line
        h1.title {{$translate('Карта')}}

    map-mapping-legend(
      :mappingCurrentLegend="mappingCurrentLegend"
    )

    div.new-map
      div(ref="map" v-once).bigmap#map

      transition(name="fade")
        div.legend.legend--objects.cuscroll(:class="showMapLegend ? 'open' : 'close'")
          div(v-if="layersLoading").hover-on-loading
          e-perfect-scrollbar
            div.head(@click="showMapLegend = !showMapLegend")
              h2.title {{$translate('Слои')}}
              //span.toolbar-filter__close
              span.legend__close(v-if="showMapLegend")
              span.legend__open(v-else)

            map-mapping-selector(
              :mappingConfObject="mappingConfObject"
              :selectedMappingObject="selectedMappingObject"
              @change="setSelectedMappingObject"
              @showEquidistant="onShowEquidistant"
              @setEquidistant="updateEquidistantCircle"
            )

            div(v-for="item, name in layersConf" :class="'type-group ' + item.menuClass")
              div.type
                label.checked
                  input.checkbox(type="checkbox" @change="onLayersChange(item, name)" v-model="layers" :value="name")
                  span
                  span.marker {{$translate(item.label)}}
                label.new-check
                  input.new-checkbox(type="checkbox")
                  span
              template(v-if="item.groups" v-for="groupItem, groupItemName in item.groups")
                div(v-if="groupItem && !groupItem.hideFromMenu").group
                  div(:class="'type ' + groupItem.menuClass")
                    label.checked
                      input.checkbox(type="checkbox" @change="onLayersChange(groupItem, groupItemName, name)" v-model="layers" :value="groupItemName")
                      span
                      span.marker {{$translate(groupItem.label)}}
    router-view
</template>

<script>
  import {map as mapEndpoints} from "../../../api/api-endpoints";
  import MapMappingLegend from "../components/map-mapping-legend";
  import MapMappingSelector from "../components/map-mapping-selector"
  import objectsMixin from '../mixins/objects-mixin'
  import mappingMixin from '../mixins/mapping-mixin'

  export default {
    mixins: [objectsMixin, mappingMixin],
    components: {MapMappingSelector, MapMappingLegend},
    methods: {
      getLayersConf () {
        return {
          gs: {
            menuClass: 'oth',
            label: 'Отходообразователи',
            endpoint: mapEndpoints.source,
            className: 'cluster-marker',
            iconType: 'wasteCreators',
            groups: {
              org: {
                menuClass: 'oth-hoz',
                iconType: 'org',
                label: 'Организация/ИП',
                restApiOrder: 2
              },
              def: {
                menuClass: 'oth-minOb',
                iconType: 'def',
                label: 'Объекты министерства обороны',
                restApiOrder: 4
              },
              med: {
                menuClass: 'oth-med',
                iconType: 'med',
                label: 'Медицинские учреждения',
                restApiOrder: 5
              },
              uk: {
                iconType: 'uk',
                menuClass: 'oth-upOrg',
                label: 'Управляющие организации',
                restApiOrder: 1
              },
              ind: {
                menuClass: 'oth-individ',
                iconType: 'ind',
                label: 'Индивидуальное домовладение',
                restApiOrder: 6
              },
              country: {
                menuClass: 'oth-garden',
                iconType: 'country',
                label: 'Садовые, дачные партнерства',
                restApiOrder: 7
              },
              gsk: {
                menuClass: 'oth-garage',
                iconType: 'gsk',
                label: 'ГСК',
                restApiOrder: 8
              },
              set: {
                menuClass: 'oth-village',
                iconType: 'set',
                label: 'Деревни, поселки, села',
                restApiOrder: 3
              }
            }
          },
          msn: {
            iconType: 'places',
            menuClass: 'places',
            label: 'Места сбора и накопления',
            endpoint: mapEndpoints.msn,
            className: 'cluster-marker msn',
            groups: {
              container: {
                menuClass: 'places-cont',
                iconType: 'container',
                label: 'Контейнерные площадки',
                restApiOrder: 1
              },
              noContainer: {
                menuClass: 'places-noCont',
                iconType: 'noContainer',
                label: 'Бесконтейнерный сбор',
                restApiOrder: 2
              },
              separate: {
                menuClass: 'places-points',
                iconType: 'separate',
                label: 'Пункты сбора вторсырья',
                restApiOrder: 3
              }
            }
          }
        }
      }
    }
  }
</script>
